import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import React from 'react';

import SEO from '@/components/common/SEO';

import GuidelinesContent from './components/GuidelinesContent';
import './CommunityGuidelines.css';

export default function CommunityGuidelines() {
    const navigate = useNavigate();

    const handleReturnClick = () => {
        // Go back if there's history, otherwise go to communities
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/communities');
        }
    };

    return (
        <section id="community-guidelines" className="page-container">
            <SEO title="Community Guidelines" />
            <Container className="py-5">
                {/* Header */}
                <Row className="mb-5">
                    <Col lg={10} className="mx-auto text-center">
                        <h1 className="text-primary mb-4">
                            Community Guidelines
                        </h1>
                    </Col>
                </Row>

                {/* Guidelines Content */}
                <div className="mb-5">
                    <GuidelinesContent />
                </div>

                {/* Return Button */}
                <Row>
                    <Col className="text-center">
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={handleReturnClick}
                        >
                            Go Back
                        </Button>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
